import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, Folder, ChevronRight } from 'lucide-react';

const StrategyNav = ({ isHovered, styles, onToggle }) => {
     const [attendanceOpen, setAttendanceOpen] = useState(false);

     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Home size={20} />
                    {isHovered && <span>Dashboard</span>}
               </NavLink>

               <NavLink to="/employee-attendance" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <CalendarCheck size={20} />
                    {isHovered && <span>Employee Attendance</span>}
               </NavLink>

               {/* Attendance Summary Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setAttendanceOpen(!attendanceOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ fontSize: 14 }}>Attendance Summary</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: attendanceOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>

                    {attendanceOpen && isHovered && (
                         <div style={{ paddingLeft: '32px' }}>
                              <NavLink
                                   to="/employee-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Employee Summary</span>
                              </NavLink>
                         </div>
                    )}
               </div>
          </>
     );
};

export const strategyNav = (isHovered, styles, onToggle) => {
     return <StrategyNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default StrategyNav;
